import { isNullOrUndefined, findRule } from '../Utils'

const validate = vObj => {
  let value = vObj.value
  let rule = findRule(vObj.errorBag, 'max')
  let length = rule.ruleParams

  //rule.feedback = `${(value ? parseInt(length) - value.length : 0)}`
  rule.feedback = `${vObj.fieldlabel} requires a maximum of ${length} characters`

  if (isNullOrUndefined(value)) {
    return length >= 0
  }

  return String(value).length <= length
}

export { validate }

export default {
  validate
}
